import { render, staticRenderFns } from "./WizardContentContainer.vue?vue&type=template&id=2353b458&scoped=true&"
import script from "./WizardContentContainer.vue?vue&type=script&lang=ts&"
export * from "./WizardContentContainer.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentContainer.vue?vue&type=style&index=0&id=2353b458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353b458",
  null
  
)

export default component.exports